// Models
PJQ.models.meetings.Meeting = PJQ.models.BaseModel.extend({
    defaults: {
        isAPIv2: true
    },
    idAttribute: 'id',
    endpoint: function () {
        if (this.isNew() && this.get('projectId')) {
            return PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'projects',
                    value: this.get('projectId')
                },
                {
                    endpoint: 'meetings',
                    value: this.id
                }
            ]);
        } else if (this.isNew() && this.get('templateId')) {
            return PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'meetings'
                },
                {
                    endpoint: 'templates',
                    value: this.get('templateId')
                },
                {
                    endpoint: 'meeting'
                }
            ]);
        } else {
            return PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'meetings',
                    value: this.id
                }
            ]);
        }
    },
    parse: function (model) {
        if (!model)
            return model;

        this.attachments = new PJQ.collections.meetings.Attachments(model.attachments);
        this.meetingRecordings = new PJQ.collections.meetings.Attachments(model.meetingRecordingAttachments);
        this.agendaItems = new PJQ.collections.meetings.AgendaItems(model.agendaItems);
        this.categories = new PJQ.collections.meetings.MeetingCategories(model.categories);
        this.attendees = new PJQ.collections.meetings.MeetingAttendees(model.attendees);

        let noCategory = new PJQ.models.meetings.MeetingCategory({
            meetingId: this.id,
            id: null,
            name: 'No Category'
        });

        this.categories.add(noCategory);

        return model;
    },
    beforeSave: function () {
        let agendaItems = this.agendaItems.getChangedModels();
        _.each(agendaItems, function (agendaItem) {
            agendaItem.beforeSave();
        }, this);

        this.set({
            attachments: this.attachments,
            meetingRecordingAttachments: this.meetingRecordings,
            attendees: this.attendees,
            agendaItems: agendaItems,
            categories: this.categories.filter(function (category) {
                return category.id !== null;
            })
        });
    },
    validateHyperlink: function () {
        let hyperlink = this.get('meetingLink'),
            urlPattern = /^(https?:\/\/)?([^\s/$.?#].[^\s]*)\.[^\s]+$/;

        if (!urlPattern.test(hyperlink)) {
            return false;
        }

        if (!hyperlink.startsWith("https://")) {
            hyperlink = "https://" + hyperlink;
        }

        return hyperlink;
    },
    isToday: function () {
        if (this.get('date')) {
            return (new Date(this.get('date').replace('Z', ''))).setHours(0, 0, 0, 0) === (new Date()).setHours(0, 0, 0, 0);
        } else {
            return false;
        }
    },
    getDateAndTime: function (dataProp = 'start') {
        let meetingDate = PJQ.helpers.dateHelpers.parseDateString(this.get('date'), false);
        if (meetingDate == null) {
            return null;
        }

        let mTime;
        if (dataProp === 'end') {
            mTime = this.get('endTime')
        } else {
            mTime = this.get('startTime')
        }

        if (_.size(mTime) === 0) {
            return null;
        }


        let timeSplit = mTime.split(':');
        if (timeSplit.length < 2) {
            return null;
        }

        let hours = parseInt(timeSplit[0]),
            minutes = parseInt(timeSplit[1]);
        if (isNaN(hours) || isNaN(minutes)) {
            return null;
        }

        meetingDate.setHours(hours, minutes);
        return meetingDate;
    },
    isOverdue: function () {
        let mDateTime = this.getDateAndTime();
        if (mDateTime == null) {
            return false;
        }

        return this.get('statusId') === PJQ.constants.meetings.meetingStatus.SCHEDULED && this.getDateAndTime() < new Date();
    },
    durationInMinutes: function () {
        let startDateTime = this.getDateAndTime(),
            endDateTime = this.getDateAndTime('end');

        if (startDateTime == null || endDateTime == null) {
            return null;
        }

        return PJQ.helpers.dateHelpers.getDateDiff(endDateTime, startDateTime, 'minutes');
    }
});

PJQ.models.meetings.CustomField = PJQ.models.customFields.CustomField.extend({
    defaults: {
        isAPIv2: true
    },
    idAttribute: 'id',
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'meetings'
            },
            {
                endpoint: 'customfields',
                value: this.get('id')
            }
        ]);
    }
});

PJQ.models.meetings.CustomFieldChoice = PJQ.models.BaseModel.extend({
    defaults: {
        isAPIv2: true
    },
    idAttribute: 'id',
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'meetings'
            },
            {
                endpoint: 'customfields',
                value: this.get('customFieldId')
            },
            {
                endpoint: 'choices',
                value: this.get('id')
            }
        ]);
    }
});

PJQ.models.meetings.Settings = PJQ.models.BaseModel.extend({
    defaults: {
        isAPIv2: true
    },
    idAttribute: 'settingId',
    endpoint: function () {
        if (this.options.projectId) {
            return PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'projects',
                    value: this.options.projectId
                },
                {
                    endpoint: 'meetings'
                },
                {
                    endpoint: 'settings'
                }
            ]);
        } else {
            return PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'meetings'
                },
                {
                    endpoint: 'settings'
                }
            ]);
        }
    }
});

PJQ.models.meetings.UserSettings = PJQ.models.BaseModel.extend({
    defaults: {
        isAPIv2: true
    },
    idAttribute: 'settingId',
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'meetings'
            },
            {
                endpoint: 'settings'
            },
            {
                endpoint: 'user'
            }
        ]);
    },
    getSettings: function (view) {
        return _.find(this.attributes.viewSettings, _.bind(function (setting) {
            return setting.view === view;
        }, this));
    }
});

PJQ.models.meetings.AgendaItem = PJQ.models.BaseModel.extend({
    defaults: {
        isAPIv2: true
    },
    idAttribute: 'id',
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'meetings',
                value: this.get('meetingId') ? this.get('meetingId') : this.options.meetingId
            },
            {
                endpoint: 'agendaitems',
                value: this.id
            }
        ]);
    },
    parse: function (model) {
        if (!model)
            return model;

        this.attachments = new PJQ.collections.meetings.Attachments(model.attachments);

        if (model && model.assignedTo) {
            if (model.assignedTo instanceof PJQ.models.BaseModel) {
                this.assignedTo = model.assignedTo;
            } else {
                this.assignedTo = new PJQ.models.contacts.Contact(model.assignedTo);
            }
        } else {
            this.assignedTo = null;
        }

        return model;
    },
    beforeSave: function () {
        this.set({
            attachments: this.attachments,
            assignedTo: this.assignedTo
        });
    },
    updateSort: function () {
        new PJQ.ajax.Request({
            endpoint: this.endpoint() + '/updatesort',
            isAPIv2: true,
            data: this.toJSON()
        }).put().done(_.bind(function (res) {

        }, this)).fail(_.bind(function (xhr, err, result) {

        }, this));
    }
});

PJQ.models.meetings.MeetingAttendee = PJQ.models.BaseModel.extend({
    defaults: {
        isAPIv2: true
    },
    idAttribute: 'id',
    parse: function (model) {
        if (!model)
            return model;

        this.attendee = new PJQ.models.contacts.Contact(model.attendee);

        return model;
    },
})

PJQ.models.meetings.MeetingCategory = PJQ.models.BaseModel.extend({
    defaults: {
        isAPIv2: true
    },
    idAttribute: 'id',
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'meetings',
                value: this.get('meetingId') ? this.get('meetingId') : this.options.meetingId
            },
            {
                endpoint: 'categories',
                value: this.id
            }
        ]);
    },
    updateSort: function () {
        new PJQ.ajax.Request({
            endpoint: this.endpoint() + '/updatesort',
            isAPIv2: true,
            data: this.toJSON()
        }).put().done(_.bind(function (res) {

        }, this)).fail(_.bind(function (xhr, err, result) {

        }, this));
    }
});

PJQ.models.meetings.Template = PJQ.models.BaseModel.extend({
    defaults: {
        isAPIv2: true
    },
    idAttribute: 'id',
    notifyName: 'Template',
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'meetings'
            },
            {
                endpoint: 'templates',
                value: !this.get('projectId') ? this.id : null
            }
        ], this.get('projectId') > 0 ? [
            {
                parameter: 'projectId',
                value: this.get('projectId')
            },
            {
                parameter: 'copyAttendees',
                value: this.get('copyAttendees')
            },
            {
                parameter: 'copyAgendaItems',
                value: this.get('copyAgendaItems')
            },
            {
                parameter: 'copyCategories',
                value: this.get('copyCategories')
            },
            {
                parameter: 'copyAttachments',
                value: this.get('copyAttachments')
            },
            {
                parameter: 'overwriteExisting',
                value: this.get('overwriteExisting')
            }
        ] : null);
    },
    parse: function (model) {
        if (!model)
            return model;

        if (model.meetings) {
            this.meetings = new PJQ.collections.meetings.Meetings(model.meetings);
        } else {
            this.meetings = new PJQ.collections.meetings.Meetings();
        }

        return model;
    }
});

PJQ.models.meetings.Attachment = PJQ.models.files.File.extend({
    defaults: {
        isAPIv2: true
    },
    idAttribute: 'id'
});
//Collections

PJQ.collections.meetings.Meetings = PJQ.collections.BaseCollection.extend({
    defaults: {
        isAPIv2: true
    },
    model: PJQ.models.meetings.Meeting,
    endpoint: function () {
        let params = [];
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'projects',
                value: this.options.projectId
            },
            {
                endpoint: 'meetings'
            }
        ], params);
    },
    getOriginMeetings: function () {
        let originMeetings = new PJQ.collections.meetings.Meetings(),
            self = this,
            nonExistentOriginMeetings = [];

        // Create a map of all meeting ids for fast existence check
        let meetingIds = this.models.map(function (model) {
            return model.id;
        });

        _.each(this.models, function (model) {
            let originMeetingId = model.get('originMeetingId');

            // Add to originMeetings if originMeetingId is null
            if (!originMeetingId) {
                originMeetings.add(model);
                model.followUpMeetings = new PJQ.collections.meetings.Meetings();
                model.followUpMeetings.add(model);
            } else if (!meetingIds.includes(originMeetingId)) {
                // If origin meeting does not exist, add it to a separate list
                nonExistentOriginMeetings.push(model);
            }
        }, this);

        // Sort the nonExistentOriginMeetings by id
        nonExistentOriginMeetings.sort(function (a, b) {
            return a.id - b.id;
        });

        // Take the first (lowest id) of each originMeetingId group as originMeeting and the rest as followUpMeetings
        let groupedNonExistentOriginMeetings = _.groupBy(nonExistentOriginMeetings, function (model) {
            return model.get('originMeetingId');
        });
        _.each(groupedNonExistentOriginMeetings, function (group) {
            let originMeeting = group[0];
            originMeetings.add(originMeeting);
            originMeeting.followUpMeetings = new PJQ.collections.meetings.Meetings();

            _.each(group, function (followUpMeeting) {
                originMeeting.followUpMeetings.add(followUpMeeting);
            });
        });

        // For each originMeeting, find and add to its followUpMeetings the meetings whose originMeetingId is its id
        _.each(originMeetings.models, function (originMeeting) {
            _.each(self.models, function (model) {
                if (model.get('originMeetingId') === originMeeting.id) {
                    originMeeting.followUpMeetings.add(model);
                }
            });
        });

        return originMeetings;
    },
    getMeetingCount: function (meetingId) {
        return _.size(this.get(meetingId).followUpMeetings);
    },
    getMeetingsFromOrigin: function (meeting) {
        let result = [],
            originMeetingId = meeting.get('originMeetingId');
        if (originMeetingId > 0) {
            result.push(...this.where({originMeetingId: originMeetingId}))
        } else {
            result.push(meeting);
            result.push(...this.where({originMeetingId: meeting.id}))
        }
        return result;
    }
});

PJQ.collections.meetings.Attachments = PJQ.collections.files.Files.extend({
    defaults: {
        isAPIv2: true
    },
    model: PJQ.models.meetings.Attachment,
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'meetings',
                value: this.options.meetingId
            },
            {
                endpoint: 'attachments'
            }
        ]);
    }
});

PJQ.collections.meetings.MeetingCategories = PJQ.collections.BaseCollection.extend({
    defaults: {
        isAPIv2: true
    },
    model: PJQ.models.meetings.MeetingCategory,
    endpoint: function () {
        let params = [];
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'meetings',
                value: this.options.meetingId
            },
            {
                endpoint: 'categories'
            }
        ], params);
    }
});

PJQ.collections.meetings.AgendaItems = PJQ.collections.BaseCollection.extend({
    defaults: {
        isAPIv2: true
    },
    model: PJQ.models.meetings.AgendaItem,
    endpoint: function () {
        let params = [];
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'meetings',
                value: this.options.meetingId
            },
            {
                endpoint: 'agendaitems'
            }
        ], params);
    }
});

PJQ.collections.meetings.MeetingAttendees = PJQ.collections.BaseCollection.extend({
    defaults: {
        isAPIv2: true
    },
    model: PJQ.models.meetings.MeetingAttendee,
    getAttendeeContacts: function () {
        return _.map(this.models, function (model) {
            return model.attendee;
        });
    }
});

PJQ.collections.meetings.CustomFields = PJQ.collections.BaseCollection.extend({
    defaults: {
        isAPIv2: true
    },
    model: PJQ.models.meetings.CustomField,
    endpoint: function () {
        let params = [];
        if (this.options.projectId) {
            return PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'projects',
                    value: this.options.projectId
                },
                {
                    endpoint: 'meetings'
                },
                {
                    endpoint: 'customfields'
                }
            ], params);
        } else {
            return PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'meetings'
                },
                {
                    endpoint: 'customfields'
                }
            ], params);
        }
    }
});

PJQ.collections.meetings.CustomFieldChoices = PJQ.collections.BaseCollection.extend({
    defaults: {
        isAPIv2: true
    },
    model: PJQ.models.meetings.CustomFieldChoice
});

PJQ.collections.meetings.Templates = PJQ.collections.BaseCollection.extend({
    defaults: {
        isAPIv2: true
    },
    model: PJQ.models.meetings.Template,
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'meetings'
            },
            {
                endpoint: 'templates'
            }
        ]);
    }
});